import {ValueObject} from '@s-ui/domain'

import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class YearSpecificationVehiclesValueObject extends ValueObject {
  #year

  constructor({year}) {
    super()
    this.#year = year
  }

  static empty() {
    return new YearSpecificationVehiclesValueObject({year: SpecificationVehiclesValueObject.empty()})
  }

  static yearString({year}) {
    return `${year}`
  }

  static createFromId({id}) {
    if (!SpecificationVehiclesValueObject.isValidId({id})) return YearSpecificationVehiclesValueObject.empty()

    return new YearSpecificationVehiclesValueObject({
      year: SpecificationVehiclesValueObject.createFromLiterals({
        id,
        name: YearSpecificationVehiclesValueObject.yearString({year: id})
      })
    })
  }

  get icon() {
    return this.#year.icon
  }

  get id() {
    return this.#year.id
  }

  get name() {
    return this.#year.name
  }

  get value() {
    return this.#year.value
  }

  isEmpty() {
    return this.#year.isEmpty()
  }
}
